import React, { FC, useState } from 'react';
import CareCard from './CareCards/CareCard';
import { Button } from '../jsxElements';
import { AccordionCareCard, CareWrapper } from './CareCards';
import { formatGoogleMapsLocationLink } from '../utils/map';
import styles from './PCPCard.module.css';
import sharedStyles from '../shared.module.css';

import { AmpFlagSet } from '../amplitude';

export interface PCPCardAttachmentData {
    pcpInfo: any;
    returnText: string;
    removeBubble: boolean;
    hideAvatar: boolean;
    showInfoOnly: boolean;
}

export const PCPCardAttachment: FC<{
    data: PCPCardAttachmentData;
    disableButtons: boolean;
    featureFlags: AmpFlagSet;
    sendMessage: (message: string) => void;
    sendPostBack: (message: string) => void;
}> = ({ data, disableButtons, featureFlags, sendMessage, sendPostBack }) => {
    const [expanded, setExpanded] = useState(true); // Opens with details showing
    const [scheduleButtonclicked, setScheduleButtonClicked] = useState(false);

    const handleClickExpand = () => {
        setExpanded((isExpanded) => !isExpanded);
    };

    const handleSchedule: () => void = () => {
        sendPostBack('requestSkill::scheduleAppointment::careType::PCP');
        setScheduleButtonClicked(true);
    };

    const providerInfo = data.pcpInfo;
    const returnText = data.returnText || '';
    const showInfoOnly = data.showInfoOnly;

    const buttonInfo = {
        amplitudeEvent: {
            eventType: 'Book appointment with PCP',
        },
        title: 'Schedule an appointment',
        data: 'Schedule an appointment',
    };

    const content = (
        <>
            <div>
                <Button
                    button={buttonInfo}
                    className={sharedStyles.careCardButton}
                    featureFlags={featureFlags}
                    onClick={handleSchedule}
                    disableButtons={disableButtons && scheduleButtonclicked}
                />
            </div>
        </>
    );
    const canSchedule =
        providerInfo?.hasVirtualTimeslots || providerInfo?.hasOfficeTimeslots;

    // const serviceIconsToShow = providerInfo?.
    const summaryContent = (
        <CareCard
            expandText={
                <div className={styles.pcpCardExpandText}>See details</div>
            }
            featureFlags={featureFlags}
            title={providerInfo?.provider?.name}
            subtitle={providerInfo?.provider?.specialty}
            picture={providerInfo?.provider?.photo}
            content={canSchedule && !showInfoOnly ? content : ''}
            phone={providerInfo?.provider?.phone}
            address={
                providerInfo?.provider?.address1
                    ? formatGoogleMapsLocationLink(
                          `${providerInfo?.provider?.address1}, ${providerInfo?.provider?.address2}`
                      )
                    : ''
            }
            serviceIcon={{
                virtual: providerInfo?.hasVirtualTimeslots,
                office: providerInfo?.hasOfficeTimeslots,
            }}
            accordion
            locationIcon
            phoneIcon
        />
    );

    const clinicInfo = {
        displayName: providerInfo?.provider?.clinic,
        openDays: providerInfo?.hours,
        address: {
            line1: providerInfo?.provider?.address1,
            line2: providerInfo?.provider?.address2,
            city: '',
            state: '',
            postalCode: '',
        },
        phone: providerInfo?.provider?.phone,
        distance: 0,
        url: '',
        waitTime: '',
        isActive: true,
        canSchedule: canSchedule,
    };

    const cardContent = (
        <div
            className="PCPCard"
            aria-label={`${providerInfo?.provider.name}`}
            onClick={handleClickExpand}
        >
            <AccordionCareCard
                clinicInfo={clinicInfo}
                expanded={expanded}
                summaryContent={summaryContent}
            />
        </div>
    );

    return (
        <CareWrapper
            cardContent={cardContent}
            disableButtons={disableButtons}
            featureFlags={featureFlags}
            returnText={returnText}
            returnDescription={
                'You can schedule an appointment with your PCP or\n' +
                'return to the main menu.'
            }
            sendMessage={sendMessage}
            loading={false}
        />
    );
};
